export type LanguageCode = 'en' | 'it' | 'fr';
type Language = {
	code: LanguageCode;
	file: `${LanguageCode}.ts`;
};

const languages: Language[] = [
	{
		code: 'en',
		file: 'en.ts',
	},
	{
		code: 'it',
		file: 'it.ts',
	},
	{
		code: 'fr',
		file: 'fr.ts',
	},
];

export default languages;
